import { render, staticRenderFns } from "./base-upload.vue?vue&type=template&id=86e2a9e2&scoped=true"
import script from "./base-upload.vue?vue&type=script&lang=js"
export * from "./base-upload.vue?vue&type=script&lang=js"
import style0 from "./base-upload.vue?vue&type=style&index=0&id=86e2a9e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e2a9e2",
  null
  
)

export default component.exports